import { z } from 'zod';

/**
 * Canonical platform vocabulary for who authored a message — the single
 * source of truth reused by the messages collection, the conversation
 * read-model turns, and the `AgentsEvent` wire shape.
 *
 *   `customer` = our end client (inbound contact).
 *   `agent`    = a LangChain AI agent reply.
 *   `operator` = a kanban operator (human) who took over the conversation.
 *   `system`   = a message dispatched automatically by the platform
 *                (e.g. proactive dispatch / disparo ativo).
 *
 * Distinct from `direction` (inbound/outbound): every outbound author
 * (`agent`, `operator`, `system`) shares `direction: 'outbound'`.
 *
 * At the LLM boundary these map to the provider message roles
 * (`customer → user`, `agent`/`operator → assistant`, `system → system`);
 * that mapping is encapsulated in the agents service `toBaseMessages()`.
 */
export const MessageAuthorSchema = z.enum(['customer', 'agent', 'operator', 'system']);
export type MessageAuthor = z.infer<typeof MessageAuthorSchema>;
